import _ from "lodash";
import { injectReducer } from "store/reducers";
import SchoolInformation from "./routes/SchoolInformation";
import AttendanceSetup from "./routes/AttendanceSetup";
import PeriodsSetup from "./routes/PeriodsSetup";
import AcademicYear from "./routes/AcademicYear";
import AcademicYearTerms from "./routes/AcademicYearTerms";
import Students from "../SchoolSetup/routes/Students";
import TeacherSetup from "../SchoolSetup/routes/TeacherSetup";
import VisitorSetup from "../SchoolSetup/routes/VisitorSetup";
import CourseSetup from "../SchoolSetup/routes/CourseSetup";
import LearningCourseSetup from "LearningCourses";
import ManageFamily from "Course/routes/ManageFamily";
import Sync from "../SchoolSetup/routes/Sync";
import SyncV2 from "../SchoolSetup/routes/SyncV2";
import NameConfigurations from "./routes/NameConfigurations";
import TimetableSync from "../SchoolSetup/routes/TimetableSync";
import AttendanceSync from "../SchoolSetup/routes/AttendanceSync";
import AssessmentSync from "../SchoolSetup/routes/AssessmentSync";
import GradesSetup from "./routes/GradesSetup";
import DownloadSheet from "../SchoolSetup/routes/DownloadSheet";
import CasExternalSupervisorSetup from "./routes/CasExternalSupervisorSetup";
import AssessmentTransfer from "./routes/AssessmentTransfer";
import UnitPlanPdfDownloadTool from "./routes/UnitPlanPdfDownloadTool";
import TpsPostImportTool from "./routes/TpsPostImportTool";
import GradebookSync from "./routes/GradebookSync";
import LTISettings from "./routes/LTISettings";
import OpenApiSetup from "./routes/OpenApiSetup";
import IntegrationsInternalTools from "./routes/IntegrationsInternalTools";
import Integrations from "./routes/Integrations";
import TurnItInSettings from "../Settings/routes/TurnItInSettings";
import YearGroups from "./routes/YearGroups";
import SFTP from "./routes/SFTP";
import LoginConfigurationManager from "./routes/LoginConfigurationManager";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { getRelativePath } from "Utils";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

//TODO:import all routes from routes folder
import { OperationalDaysAndTimeZone } from "./routes";
import IntegrationAnalytics from "./routes/IntegrationAnalytics";

export default store => ({
  path: "schoolSetup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./components/SchoolSetup"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./modules/SchoolSetupModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./modules/StudentEnrollModalModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "ResetInviteAndSignInCodeModal/modules/ResetInviteAndSignInCodeModalModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup" */ "./modules/StaffEnrollModalModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const studentEnrollModalModule = importedModule2.default;
          const resetInviteAndSignInCodeModalModule = importedModule3.default;
          const staffEnrollModalModule = importedModule4.default;
          injectReducer(store, {
            key: "schoolSetup",
            reducer,
          });
          injectReducer(store, {
            key: "studentEnrollModal",
            reducer: studentEnrollModalModule,
          });
          injectReducer(store, {
            key: "resetInviteAndSignInCodeModal",
            reducer: resetInviteAndSignInCodeModalModule,
          });
          injectReducer(store, {
            key: "staffEnrollModal",
            reducer: staffEnrollModalModule,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path == "schoolSetup") {
      const route = getNextMenuRoute("SCHOOL_SETUP");
      if (route) {
        replace(getRelativePath(route));
      } else {
        replace(getRelativePath("../"));
      }
    }
  },
  childRoutes: [
    TurnItInSettings(store),
    SchoolInformation(store),
    AcademicYear(store),
    AcademicYearTerms(store),
    GradesSetup(store),
    AttendanceSetup(store),
    PeriodsSetup(store),
    Students(store),
    TeacherSetup(store),
    CourseSetup(store),
    LearningCourseSetup(store),
    Sync(store),
    SyncV2(store),
    Integrations(store),
    NameConfigurations(store),
    VisitorSetup(store),
    ManageFamily(store),
    DownloadSheet(store),
    GradesSetup(store),
    CasExternalSupervisorSetup(store),
    OperationalDaysAndTimeZone(store),
    TimetableSync(store),
    AssessmentTransfer(store),
    UnitPlanPdfDownloadTool(store),
    TpsPostImportTool(store),
    AttendanceSync(store),
    AssessmentSync(store),
    GradebookSync(store),
    IntegrationAnalytics(store),
    LTISettings(store),
    OpenApiSetup(store),
    YearGroups(store),
    SFTP(store),
    IntegrationsInternalTools(store),
    LoginConfigurationManager(store),
  ],
});
